module.exports = __webpack_public_path__ + "static/media/author-4.4a8ca310.png";